import * as React from "react"
import { cn } from "../../lib/cn"
import { Button } from "./button"

export interface IconButtonProps
    extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    icon: React.ReactNode;
    ariaLabel: string;
    variant?: "icon" | "ghost" | "secondary";
    size?: "default" | "dense";
    intent?: string; // legacy support
    isLoading?: boolean;
}

const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
    ({ className, variant = "icon", size = "default", intent, icon, ariaLabel, isLoading, ...props }, ref) => {
        // Handle legacy intent conversions to valid variants
        let effectiveVariant = variant;
        if (intent && (intent === 'ghost' || intent === 'secondary' || intent === 'icon')) {
            effectiveVariant = intent as any;
        } else if (intent) {
            effectiveVariant = "icon";
        }

        return (
            <Button
                ref={ref}
                variant={effectiveVariant}
                size={size === 'dense' ? 'icon-dense' : 'icon'}
                className={cn("flex-shrink-0 flex items-center justify-center", className)}
                aria-label={ariaLabel}
                isLoading={isLoading}
                {...props}
            >
                {icon}
            </Button>
        )
    }
)
IconButton.displayName = "IconButton"

export { IconButton }
